module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/selo-sem-luz-desk-ffa6b58d67a1e3101ca78a9bc511e93f.png";